/* eslint-disable max-len */
import {
  SET_VEHICLE_TYPES,
  SET_VEHICLE_BRANDS,
  SET_VEHICLE_MODELS,
  SET_SIMULATION,
  DELETE_SIMULATION,
} from '@/stores/constants'

import {
  getVehicleTypes,
  getVehicleBrands,
  getVehicleModels,
} from '@/services/simulasi'

/**
 * =========================
 * Helpers (encode / decode)
 * =========================
 */
const STORAGE_KEY = 'dicicilSimulation'

const encode = data =>
  window.btoa(unescape(encodeURIComponent(JSON.stringify(data))))

const decode = data =>
  JSON.parse(decodeURIComponent(escape(window.atob(data))))

/**
 * =========================
 * Initial State (REHYDRATE)
 * =========================
 */
const savedSimulation = localStorage.getItem(STORAGE_KEY)

const state = {
  vehicleTypes: [],
  vehicleBrands: [],
  vehicleModels: [],
  simulation: savedSimulation ? decode(savedSimulation) : null,
}

/**
 * =========================
 * Getters
 * =========================
 */
const getters = {
  getVehicleTypes: state => state.vehicleTypes,
  getVehicleBrands: state => state.vehicleBrands,
  getVehicleModels: state => state.vehicleModels,
  getSimulation: state => state.simulation,
}

/**
 * =========================
 * Mutations
 * =========================
 */
const mutations = {
  [SET_VEHICLE_TYPES](state, data) {
    state.vehicleTypes = data
  },

  [SET_VEHICLE_BRANDS](state, data) {
    state.vehicleBrands = data
  },

  [SET_VEHICLE_MODELS](state, data) {
    state.vehicleModels = data
  },

  [SET_SIMULATION](state, data) {
    state.simulation = data
    localStorage.setItem(STORAGE_KEY, encode(data))
  },

  [DELETE_SIMULATION](state) {
    state.simulation = null
    localStorage.removeItem(STORAGE_KEY)
  },
}

/**
 * =========================
 * Actions
 * =========================
 */
const actions = {
  async fetchVehicleTypes({ commit }) {
    const result = await getVehicleTypes()
    commit(SET_VEHICLE_TYPES, result.data.data)
  },

  async fetchVehicleBrands({ commit }, typeId) {
    const result = await getVehicleBrands(typeId)
    commit(SET_VEHICLE_BRANDS, result.data.data)
  },

  async fetchVehicleModels({ commit }, brandId) {
    const result = await getVehicleModels(brandId)
    commit(SET_VEHICLE_MODELS, result.data.data)
  },

  setSimulation({ commit }, data) {
    commit(SET_SIMULATION, data)
  },

  deleteSimulation({ commit }) {
    commit(DELETE_SIMULATION)
  },

  /**
   * =========================
   * INIT FROM LOCAL STORAGE
   * =========================
   */
  initSimulation({ commit }) {
    const saved = localStorage.getItem(STORAGE_KEY)
    if (saved) {
      commit(SET_SIMULATION, decode(saved))
    }
  },
}

/**
 * =========================
 * Export
 * =========================
 */
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
